<script>
import Search from './Search';
import i18n from '@/lib/i18n';
import { Collection, TrancheCollection } from '@/models';
import toCurrency from '@/lib/helpers/toCurrency';
import toDate from '@/lib/helpers/toDate';

export default {
    name: 'Tranche',
    extends: Search,
    props: {
        label: {
            type: String,
            default: i18n.t('tranche')
        },
        collection: {
            type: Collection,
            default: () => new TrancheCollection()
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: [String, Function],
            default: () => item => {
                let text = '';

                if (item.investor) {
                    text += item.investor.name + ' - ';
                }

                if (item.fund) {
                    text += item.fund.name;
                }

                return text || i18n.t('tranche');
            }
        },
        itemTooltip: {
            type: [String, Function],
            default: () => item => {
                let tooltip = [];

                tooltip.push(`${i18n.t('adviser')}: ${item.adviser?.name || '-'}`);

                tooltip.push(
                    `${i18n.t('total_investment')}: ${
                        item.total_investment
                            ? toCurrency(item.total_investment.amount, item.total_investment.currency)
                            : '-'
                    }`
                );

                tooltip.push(
                    `${i18n.t('cash_balance')}: ${
                        item.cash_balance ? toCurrency(item.cash_balance.amount, item.cash_balance.currency) : '-'
                    }`
                );

                tooltip.push(`${i18n.t('invested_on')}: ${item.invested_on ? toDate(item.invested_on) : '-'}`);

                return tooltip;
            }
        }
    },
    data: () => ({
        createForm: () => import('@/components/forms/CreateTranche')
    })
};
</script>
